<template>
	 <div class="card panel-success">
      <div class="card-header">List Task</div>
      <table class="table table-hover ">
        <thead>
          <tr>
            <th style="width: 10%" class="text-center">#</th>
            <th>Task</th>
            <th style="width: 20%" class="text-center">Level</th>
            <th style="width: 160px">Action</th>
          </tr>
        </thead>

        <tbody v-if = "listTask.length > 0">
        	<todo-list-item
			v-for="(taskrender, index) in listTask" :key = "taskrender.id"
			:taskToProp = "taskrender"
			:taskIndex = "index + 1"
			@handleDeleteApp = "handleDeleteApp"
			@handleEditApp = "handleEditApp"
        	/>
        	
        </tbody>

        <tbody v-else>
			<tr>
				<td colspan="4">List is empty</td>
			</tr>
        	
        	
        </tbody>

      </table>
    </div>
</template>
<script>
	import TodoListItem from './TodoListItem.vue'
	export default {
		name: "todo-list-table",
		props: {
			listTask: {type: Array, default: []}
		},
		data: function(){
			return {

			}
		},
		components: {
			TodoListItem
		},

		methods: {
			handleDeleteApp: function(data){
				this.$emit("handleDeleteAppVue", data);
			},

			handleEditApp: function(taskIndex){
				this.$emit("handleEditAppMain", taskIndex)
			}
		}
	}
	
</script>
<style type="text/css"></style>
